import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../../shared/context/auth-context";
import ModalNotificar from "../../../../../shared/components/modalMedicos/ModalNotificar";
import UpcomingAppointmentsComponent from "../UpcomingAppointmentsComponent";
import toast from "react-hot-toast";
import { useWebSocketSubscription } from "../../../../../shared/context/websocket-context";

import "./InfoGeral.scss";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import FaltaInfoTooltip from "./faltaInfoTooltip/FaltaInfoTooltip";
import ModalUrgencia from "./ModalUrgencia/ModalUrgencia";
import ModalDispensarUrgencia from "../../../../../shared/components/urgencia/ModalDispensarUrgencia";
//MUI
import InfoIcon from "@mui/icons-material/Info";
import PaymentIcon from "@mui/icons-material/Payment";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Tooltip from "@mui/material/Tooltip";
import UpcomingAppointmentsTratamentoComponent from "../UpcomingAppointmentsTratamentoComponent";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";
import NaoExecucaoInfoTooltip from "./naoexecutadasinfoTooltip/NaoExecucaoInfoTooltip ";
import PdfAnamnese from "../../../../../shared/components/PdfGenerator/pdfAnamnese/PdfAnamnese";
import moment from "moment/moment";
import { Printer } from "lucide-react";

function InfoGeral({
  clienteId,
  clinicaId,
  sendRequest,
  userData,
  balancoGeralCliente,
  dadosProximosAgendamentos,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [showAnamnese, setShowAnamnese] = useState(false);
  const [imprimirAnamnese, setImprimirAnamnese] = useState(false);
  const [emUrgencia, setEmUrgencia] = useState(false);
  const [mostrarModalUrgencia, setMostrarModalUrgencia] = useState(false);
  /* Cancelar uma urgencia e dispensa-la: pede-se o motivo, como na lista. */
  const [mostrarDispensa, setMostrarDispensa] = useState(false);
  const [dispensando, setDispensando] = useState(false);
  const [nrOrcamentosPlanos, setNrOrcamentosPlanos] = useState({
    orcamentosCriados: 0,
    planosConcluidos: 0,
  });
  const [estatisticasFaltasCliente, setEstatisticasFaltasCliente] =
    useState(null);

  const [estatisticasNaoExecucaoCliente, setEstatisticasNaoExecucaoCliente] =
    useState(null);

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const navigate = useNavigate();

  const [modalMedicosProps, setModalNotificarProps] = useState({
    show: false,
    medicos: [],
    handleModalNotificarClose: null,
    handleModalNotificarSubmit: null,
  });

  const avaliarButtonClickHandler = () => {
    setModalNotificarProps({
      show: true,
      medicos: auth.usuariosAssociados,
      handleModalNotificarClose: handleModalNotificarClose,
      handleModalNotificarSubmit: handleModalNotificarSubmit,
    });
  };

  const handleModalNotificarClose = () => {
    setModalNotificarProps((current) => {
      return {
        ...current,
        show: false,
      };
    });
  };

  const handleModalNotificarSubmit = async (
    tipoNotificacao,
    medicoId,
    medicoNome,
    observacao = ""
  ) => {
    startLoading();
    setModalNotificarProps((current) => {
      return {
        ...current,
        show: false,
      };
    });
    try {
      const notificationFormData = new FormData();
      notificationFormData.append("cliente", clienteId);
      notificationFormData.append("clinica", clinicaId);

      let notificationUsers = [];

      const assistentes = auth.assistentesDoMedico
        ? auth.assistentesDoMedico.find((m) => m.medicoId === medicoId)
            .assistentes
        : [];
      notificationUsers = [medicoId, ...assistentes];

      notificationFormData.append("medicoId", medicoId);
      notificationFormData.append("medicoNome", medicoNome);
      notificationFormData.append("user", JSON.stringify(notificationUsers));
      notificationFormData.append("tipo", `espera ${tipoNotificacao}`);
      notificationFormData.append(
        "mensagem",
        `${auth.nome} notifica que ${userData.nome} está à espera para efetuar uma ${tipoNotificacao}`
      );
      // A observação vai em `dados` (não na mensagem) para poder ser mostrada
      // com destaque próprio na notificação do médico.
      if (observacao) {
        notificationFormData.append("dados", JSON.stringify({ observacao }));
      }

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/notificacoes`,
        "POST",
        notificationFormData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      toast.success(`Médico notificado da ${tipoNotificacao}!`);
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  useWebSocketSubscription(
    async (parsedSocketData) => {
      if (parsedSocketData.tabela !== "urgencias") return;

      /* Antes isto punha `emUrgencia` a falso em QUALQUER update da coleção —
         incluindo o de outro paciente. O botão da ficha aberta mudava para
         «Marcar Urgência» enquanto a urgência deste continuava aberta. */
      const doc = parsedSocketData.documento;
      if (doc?.cliente && String(doc.cliente) !== String(clienteId)) return;

      if (parsedSocketData.tipoDeOperacao === "insert") {
        setEmUrgencia(true);
        return;
      }

      if (parsedSocketData.tipoDeOperacao === "update") {
        /* Atendida ou cancelada deixa de estar em curso. Qualquer outro update
           (a escalada grava o nível) não mexe no botão. */
        if (doc?.atendido === true || doc?.ativo === false) {
          setEmUrgencia(false);
        }
      }
    },
    [auth.userId, auth.token, auth.role, clienteId],
    "InfoGeral"
  );

  useEffect(() => {
    const fetchUrgencias = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/urgencias/cliente/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        if (responseData.urgencia.length > 0) setEmUrgencia(true);
        else setEmUrgencia(false);
      } catch (err) {}
    };
    fetchUrgencias();

    const fetchNrOrcamentosCriadosPlanosConcluidos = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/orcamentosplanos/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        setNrOrcamentosPlanos(responseData);
      } catch (err) {}
    };
    fetchNrOrcamentosCriadosPlanosConcluidos();

    const fetchEstatisticasFaltasCliente = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/${
            clinica.clinica.configuracoes.configuracoes.tipoAgendamento.tipo ===
            "Tratamento"
              ? "agendatratamento"
              : "agenda"
          }/getEstatisticasFaltasCliente/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        setEstatisticasFaltasCliente(responseData);
      } catch (err) {}
    };
    fetchEstatisticasFaltasCliente();

    const fetchEstatisticasNaoExecucaoCliente = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/${
            clinica.clinica.configuracoes.configuracoes.tipoAgendamento.tipo ===
            "Tratamento"
              ? "agendatratamento"
              : "agenda"
          }/getEstatisticasNaoExecucaoCliente/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        setEstatisticasNaoExecucaoCliente(responseData);
      } catch (err) {}
    };
    fetchEstatisticasNaoExecucaoCliente();
  }, [auth.token, clienteId, sendRequest]);

  /* Marcar abre um modal — é lá que se diz ao que a pessoa vem e a quem avisar.
     Cancelar abre outro: cancelar É dispensar, e sem o motivo «Dispensada» no
     relatório não se interpreta. */
  const marcacaoUrgenciaHandler = () => {
    if (!emUrgencia) setMostrarModalUrgencia(true);
    else setMostrarDispensa(true);
  };

  const cancelarUrgencia = async ({ motivoDispensa, notaDispensa }) => {
    setDispensando(true);
    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/urgencias/${clienteId}`,
        "DELETE",
        JSON.stringify({ motivoDispensa, notaDispensa }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      setEmUrgencia(false);
      setMostrarDispensa(false);
      toast.success("Marcação de Urgência cancelada!");
    } catch (err) {
      toast.error(err.message || "Não foi possível cancelar a urgência.");
    } finally {
      setDispensando(false);
    }
  };

  return (
    <>
      {imprimirAnamnese && userData.anamnese && (
        <PdfAnamnese
          anamneseData={{
            cliente: {
              nome: userData.nome,
              contacto: userData.contacto,
              morada: userData.endereco,
              idade: userData.data_nasc
                ? moment().diff(moment(userData.data_nasc), "years")
                : "",
              profissao: userData.profissao || "",
            },
            clinica: clinica.clinica,
            medico: auth,
          }}
          showPreviousPage={() => setImprimirAnamnese(false)}
        />
      )}
      {modalMedicosProps.show && <ModalNotificar {...modalMedicosProps} />}
      <div className="singleContainer__info-geral">
        <div className="singleContainer__users-face caixa">
          {auth.perm.includes("u-cli") && (
            <span
              className="cliente__edit-btn absolute-positioned-edit-btn"
              onClick={() => navigate(`../../${userData.id}/edit`)}
            >
              Editar
            </span>
          )}
          {userData.foto ? (
            <img
              src={`${process.env.REACT_APP_BACKEND_LINK}/${userData.foto}`}
              alt=""
              className="profileImg"
            />
          ) : (
            <svg version="1.1" viewBox="0 0 256 256">
              <g
                className="gUserIconStyle"
                transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
              >
                <path
                  className="pathUserIconStyle"
                  d="M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 45 22.007 c 8.899 0 16.14 7.241 16.14 16.14 c 0 8.9 -7.241 16.14 -16.14 16.14 c -8.9 0 -16.14 -7.24 -16.14 -16.14 C 28.86 29.248 36.1 22.007 45 22.007 z M 45 83.843 c -11.135 0 -21.123 -4.885 -27.957 -12.623 c 3.177 -5.75 8.144 -10.476 14.05 -13.341 c 2.009 -0.974 4.354 -0.958 6.435 0.041 c 2.343 1.126 4.857 1.696 7.473 1.696 c 2.615 0 5.13 -0.571 7.473 -1.696 c 2.083 -1 4.428 -1.015 6.435 -0.041 c 5.906 2.864 10.872 7.591 14.049 13.341 C 66.123 78.957 56.135 83.843 45 83.843 z"
                  transform=" matrix(1 0 0 1 0 0) "
                  strokeLinecap="round"
                />
              </g>
            </svg>
          )}
          <span className="profileName">{userData.nome}</span>

          <span className="profileEmail">
            {userData.email ? userData.email : ""}
          </span>

          <div className="profileOther">
            <div className="profileOther1">
              <span className="number">
                {nrOrcamentosPlanos.orcamentosCriados}
              </span>
              <span className="text">Orçamentos criados</span>
            </div>
            <div className="profileOther2">
              <span className="number">
                {nrOrcamentosPlanos.planosConcluidos}
              </span>
              <span className="text">Planos concluidos</span>
            </div>
          </div>

          {auth.perm.includes("c-notiUA") && auth.role === "Secretária(o)" && (
            <div className="single-big-btns">
              <span
                className="marcacao-avaliacao-btn single-big-btn"
                onClick={avaliarButtonClickHandler}
              >
                Notificar
              </span>

              <span
                className={`single-big-btn ${
                  emUrgencia ? "emUrgencia-btn" : "marcacao-urgencia-btn"
                }`}
                onClick={marcacaoUrgenciaHandler}
              >
                {emUrgencia ? "Cancelar Urgência" : "Marcar Urgência"}
              </span>

              <ModalUrgencia
                aberto={mostrarModalUrgencia}
                fechar={() => setMostrarModalUrgencia(false)}
                clienteId={clienteId}
                clinicaId={clinicaId}
                /* Faltava, e o modal mostrava uma linha em branco onde devia
                   estar o nome do doente que se vai marcar. */
                clienteData={userData}
                aoMarcar={() => setEmUrgencia(true)}
              />

              <ModalDispensarUrgencia
                aberto={mostrarDispensa}
                fechar={() => setMostrarDispensa(false)}
                nomeCliente={userData?.nome}
                aoConfirmar={cancelarUrgencia}
                aEnviar={dispensando}
              />
            </div>
          )}

          {(auth.role === "Médico/Administrador" ||
            auth.role === "Dentista") && (
            <div className="single-anamnese--div">
              <span
                className="single-anamnese--btn"
                onClick={() => setShowAnamnese((current) => !current)}
              >
                {showAnamnese ? "Ver Geral" : "Ver Anamnese"}
              </span>
            </div>
          )}
        </div>
        {!showAnamnese && (
          <div className="singleContainer__users-info caixa">
            <div className="singleContainer__users-info--division">
              <div className="userInfo-box">
                <span className="userInfo-box_title">Género</span>
                <span className="userInfo-box_description">
                  {userData.genero}
                </span>
              </div>

              <div className="userInfo-box">
                <span className="userInfo-box_title">data nascimento</span>
                <span className="userInfo-box_description">
                  {userData.data_nasc}
                </span>
              </div>

              <div className="userInfo-box">
                <span className="userInfo-box_title">Contacto</span>
                <span className="userInfo-box_description">
                  {userData.contacto}
                </span>
              </div>
            </div>

            <div className="singleContainer__users-info--division">
              <div className="userInfo-box">
                <span className="userInfo-box_title">endereço</span>
                <span className="userInfo-box_description">
                  {userData.endereco}
                </span>
              </div>

              <div className="userInfo-box">
                <span className="userInfo-box_title">profissão</span>
                <span className="userInfo-box_description">
                  {userData.profissao}
                </span>
              </div>

              <div className="userInfo-box">
                <span className="userInfo-box_title">Nif</span>
                <span className="userInfo-box_description">{userData.nif}</span>
              </div>
            </div>

            <div className="singleContainer__users-info--division">
              <div className="userInfo-box">
                <span className="userInfo-box_title">% Faltas</span>
                <span
                  className="userInfo-box_description"
                  style={{ textAlign: "right" }}
                >
                  {estatisticasFaltasCliente?.percentagemFaltasTotal || 0}%
                </span>
              </div>

              <div className="userInfo-box">
                <span className="userInfo-box_title">Nr. Faltas</span>
                {estatisticasFaltasCliente && (
                  <FaltaInfoTooltip
                    estatisticasFaltas={estatisticasFaltasCliente}
                  />
                )}
              </div>

              {/* <div className="userInfo-box">
                <span className="userInfo-box_title">Permissões</span>
                <span className="userInfo-box_description">
                  {userData.sms && "sms,"}
                  {userData.com_whatsapp && "whatsapp,"}
                  {userData.com_email && "email"}
                  {!userData.sms &&
                    !userData.com_whatsapp &&
                    !userData.com_email &&
                    "Nenhuma"}
                </span>
              </div> */}

              <div className="userInfo-box">
                <span className="userInfo-box_title">Nr. Não Exec.</span>
                {estatisticasNaoExecucaoCliente && (
                  <NaoExecucaoInfoTooltip
                    estatisticasNaoExecucao={estatisticasNaoExecucaoCliente}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        {showAnamnese && (
          <div className="singleContainer__users-anamnese-info caixa">
            {!userData.anamnese &&
              (auth.role === "Médico/Administrador" ||
                auth.role === "Dentista") && (
                <span
                  className="single-btn-newAnamnese"
                  onClick={() =>
                    navigate(`../../../anamnese/${userData.id}/new`)
                  }
                >
                  Criar Anamnese
                </span>
              )}
            {userData.anamnese &&
              (auth.role === "Médico/Administrador" ||
                auth.role === "Dentista") && (
                <>
                  <div className="anamnese__action-btns">
                    <span
                      className="anamnese__action-btns__imprimir"
                      onClick={() => setImprimirAnamnese(true)}
                      title="Imprimir Anamnese"
                    >
                      <Printer size={18} />
                    </span>
                    <span
                      className="anamnese__action-btns__editar"
                      onClick={() =>
                        navigate(
                          `../../../anamnese/${userData.anamnese.id}-${
                            userData.id
                          }-${userData.nome.split(" ")[0]}-${
                            userData.nome.split(" ")[1]
                          }/edit`
                        )
                      }
                    >
                      Editar
                    </span>
                  </div>

                  <span className="anamnese__texto">
                    {userData.anamnese.estadoGeralSaude &&
                      userData.anamnese.estadoGeralSaude + "."}
                    {`${
                      userData.anamnese.sobCuidadosMedicos
                        ? " Está sob cuidados médicos."
                        : " Não está sob cuidados médicos."
                    }`}
                    {userData.anamnese.gravidez ? " Grávida" : ""}
                    {`${
                      userData.anamnese.foiHospitalizado
                        ? userData.genero === "feminino"
                          ? " Já foi hospitalizada."
                          : " Já foi hospitalizado."
                        : userData.genero === "feminino"
                        ? " Nunca foi hospitalizada."
                        : " Nunca foi hospitalizado."
                    }`}
                    {`${
                      userData.anamnese.alergias
                        ? ` Sofre de alergias: ${userData.anamnese.alergias}.`
                        : "Não sofre de alergias"
                    }`}
                    {`${
                      userData.anamnese.doencas
                        ? ` Já teve doenças graves: ${userData.anamnese.doencas}.`
                        : " Nunca teve doenças graves."
                    }`}
                    {`${
                      userData.anamnese.medicamentos
                        ? ` Toma os seguintes medicamentos: ${userData.anamnese.medicamentos}.`
                        : " Não toma medicamentos."
                    }`}
                  </span>
                </>
              )}
          </div>
        )}
      </div>

      {auth.perm.includes("r-cli") && (
        <div className="infoGeral__agendamentoEbalanco">
          {balancoGeralCliente.balancosFinanceiros.length > 0 && (
            <div className="infoGeral__agendamentoEbalanco__balanco caixa">
              {balancoGeralCliente.balancosFinanceiros.map((balanco) => (
                <div
                  className="infoGeral__agendamentoEbalanco__balanco__item"
                  key={balanco.orcamentoId}
                >
                  <span
                    className={`infoGeral__agendamentoEbalanco__balanco__item__titulo ${
                      balanco.statusRisco === "ALTO"
                        ? "infoGeral__agendamentoEbalanco__balanco__item--altoRisco"
                        : balanco.statusRisco === "MÉDIO"
                        ? "infoGeral__agendamentoEbalanco__balanco__item--medioRisco"
                        : "infoGeral__agendamentoEbalanco__balanco__item--baixoRisco"
                    }`}
                  >
                    Orcamento: {balanco.orcamentoCodigo} - RISCO{" "}
                    {balanco.statusRisco}
                  </span>

                  <div className="percentuais-container">
                    <span className="percentuais-container__item">
                      <Tooltip title="Percentual de procedimentos executados em relação ao valor total do orçamento">
                        <InfoIcon fontSize="small" color="primary" />
                      </Tooltip>
                      {Math.ceil(Number(balanco.percentualExecutado))}%
                    </span>
                    <span className="percentuais-container__item">
                      <Tooltip title="Percentual do valor pago em relação ao valor total do orçamento">
                        <PaymentIcon fontSize="small" color="success" />
                      </Tooltip>
                      {Math.ceil(Number(balanco.percentualPago))}%
                    </span>
                    <span className="valores-container__item">
                      <Tooltip title="Valor total dos procedimentos já executados">
                        <MedicalServicesIcon fontSize="small" color="info" />
                      </Tooltip>
                      {balanco.valorExecutado?.toLocaleString("pt-BR") + "CVE"}
                    </span>
                    <span className="valores-container__item">
                      <Tooltip title="Valor total já pago pelo cliente">
                        <AccountBalanceWalletIcon
                          fontSize="small"
                          color="secondary"
                        />
                      </Tooltip>
                      {balanco.valorPago?.toLocaleString("pt-BR") + "CVE"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="single__container__proximos-agendamentos infoGeral__agendamentoEbalanco__agendamento caixa">
            <h2 className="single__container__proximos-agendamentos__titulo">
              Agendamentos
            </h2>
            {clinica.clinica.configuracoes.configuracoes.tipoAgendamento
              .tipo === "Tratamento" ? (
              <UpcomingAppointmentsTratamentoComponent
                clienteId={clienteId}
                sendRequest={sendRequest}
                dadosProximosAgendamentos={dadosProximosAgendamentos}
              />
            ) : (
              <UpcomingAppointmentsComponent
                clienteId={clienteId}
                sendRequest={sendRequest}
                dadosProximosAgendamentos={dadosProximosAgendamentos}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default InfoGeral;
